import client from "../client";

export const profilesApi = {
    async list(params = {}) {
        const { data } = await client.get("/profiles", { params });
        return data;
    },
    async listArchived() {
        const { data } = await client.get("/profiles/archived");
        return data;
    },
    async get(id) {
        const { data } = await client.get(`/profiles/${id}`);
        return data;
    },
    async getByRegNo(reg) {
        const { data } = await client.get(`/profiles/by-reg-no/${encodeURIComponent(reg)}`);
        return data;
    },
    async remove(id) {
        const { data } = await client.delete(`/profiles/${id}`);
        return data;
    },
    /**
     * PATCH /profiles/{id} — partial update; only fields the FE explicitly
     * sends are written (BE uses exclude_unset). Use this from the Edit
     * flow so untouched fields are preserved.
     * @param {{childData?: object, familyData?: object}} payload
     */
    async update(id, payload) {
        const { data } = await client.patch(`/profiles/${id}`, payload);
        return data;
    },
};
